/**
 * User: Nikolai Gorte * Date: 17.11.23 * Time: 16:09
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';
export const BaseToolbar = ({className, children}) => {

  return (
    <div className={`base-toolbar ${className}`}>
      {children}
    </div>
  );
};

BaseToolbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./js/components/BaseToolbar.jsx